'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawSelect = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _values = require('./values');

var _values2 = _interopRequireDefault(_values);

var _lodash = require('lodash');

var _reactFulcrum = require('@upgrowth/react-fulcrum');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var supportedProps = [// Html
'required', 'placeholder', 'disabled'];
var RawSelect = exports.RawSelect = (0, _values2.default)(function (_ref) {
  var value = _ref.value,
      values = _ref.values,
      onChange = _ref.onChange,
      type = _ref.type; // export const RawSelect = values(({name, type, context, value, values}: Props) => {

  var availableOptions = (0, _lodash.map)(values, function (v, k) {
    return {
      value: k || '',
      key: k || '',
      label: typeof v === "string" ? v : k
    };
  });
  var existingSelection = (0, _lodash.map)((0, _lodash.castArray)(value), function (v) {
    return {
      value: v || '',
      key: v || '',
      label: v
    };
  });
  var options = (0, _lodash.uniqBy)([{
    key: "",
    label: "-- NONE --",
    value: ''
  }].concat((0, _toConsumableArray3.default)(availableOptions), (0, _toConsumableArray3.default)(existingSelection)), 'key');
  var defaults = {
    search: true
  };
  var passProps = (0, _extends3.default)({}, defaults, type);
  var _type$defaultValue = type.defaultValue,
      defaultValue = _type$defaultValue === undefined ? undefined : _type$defaultValue,
      _type$variant = type.variant,
      variant = _type$variant === undefined ? "primary" : _type$variant;
  return _react2.default.createElement(_reactFulcrum.Select, (0, _extends3.default)({
    className: 'SelectEditor variant-' + variant,
    clearable: false
  }, passProps, {
    onChange: onChange,
    value: value === undefined ? defaultValue : value,
    options: options
  }));
});

exports.default = function (_ref2) {
  var name = _ref2.name,
      type = _ref2.type,
      context = _ref2.context;
  var values = type.values;
  var path = context.path,
      _onChange = context.onChange,
      value = context.value;
  return _react2.default.createElement(RawSelect, {
    values: values,
    type: type,
    onChange: function onChange(value) {
      return _onChange(path, value);
    },
    value: value,
    context: context
  });
};